'use client';

import clsx from 'clsx';
import styles from './PostCard.module.scss';
import Img from '@/components/Img';
import Button, { ButtonType } from '@/components/Button/Button';
import { Link } from '@/i18n/navigation';
import Category from '../Category/Category';

export type PostType = {
  author: {
    bio: string;
    id: number;
    name: string;
    avatar: {
      url: string;
    };
  };
  blogPostCategories: {
    id: number;
    name: string;
  }[];
  content: string;
  summaryTitle: string;
  summaryDescription: string;
  title: string;
  shortDescription: string;
  description: string;
  createdAt: string;
  slug: string;
  id: number;
  image?: {
    url: string;
  };
  readTime: number;
};

export const HIDE_CATEGORY_AND_READ_TIME = true;

const PostCard = ({
  post,
  isSliderCard,
}: {
  post: PostType;
  isSliderCard?: boolean;
}) => (
  <Link
    className={clsx(styles.post, post.slug && styles.postLink, { [styles.isSliderCard]: isSliderCard })}
    href={`/blog/${post.slug}`}
  >
    {post.image && (
      <div className={styles.postImageContainer}>
        <Img
          className={styles.postImage}
          src={post.image.url}
          alt={post.title}
        />
      </div>
    )}
    {(!HIDE_CATEGORY_AND_READ_TIME && post.blogPostCategories && post.readTime) && (
      <div className={styles.postInfo}>
        {post.blogPostCategories.length > 0 && (
          <Category category={post.blogPostCategories[0].name} />
        )}
        {post.readTime && (
          <div className={styles.postRead}>
            <span>
              {post.readTime}
              {' '}
              min read
            </span>
          </div>
        )}
      </div>
    )}
    <h5 className={styles.postTitle}>{post.title}</h5>
    <p className={styles.postDescription}>{post.shortDescription}</p>
    {post.slug && (
      <div className={styles.postLinkContainer}>
        <Button
          className={styles.postLink}
          type={ButtonType.TEXT_LIGHT}
          iconName='arrow_forward'
          iconPosition='right'
        >
          Read more
        </Button>
      </div>
    )}
  </Link>
);

export default PostCard;
